import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { CONSULT_URL } from '../config/constants';

const { FiTrendingUp, FiPhone } = FiIcons;

const Header = () => {
  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white shadow-sm border-b"
    >
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img src="https://wowdigital.com/logo_black.png" alt="Wow Digital Logo" className="max-w-[187.5px] h-auto" />
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center space-x-2 text-[#0066FF] hidden md:flex">
              <SafeIcon icon={FiTrendingUp} className="text-lg" />
              <span className="font-semibold">Impact Calculator</span>
            </div>
            <a
              href={CONSULT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-[#0066FF] to-[#7A1AE2] text-white text-sm font-bold px-4 py-2 rounded-lg hover:shadow-lg hover:-translate-y-0.5 transition-all flex items-center gap-2"
            >
              <SafeIcon icon={FiPhone} className="text-xs" /> Book Free Call
            </a>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;